/* quick-view.js — modal populated from /products/{handle}.js, no page reload */

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector("[data-quick-view-modal]");
  if (!modal) return;

  const body = modal.querySelector("[data-quick-view-body]");
  const closers = modal.querySelectorAll("[data-quick-view-close]");

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-quick-view]");
    if (!trigger) return;
    e.preventDefault();
    openQuickView(trigger.dataset.productHandle);
  });

  closers.forEach(btn => btn.addEventListener("click", closeModal));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeModal(); });

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = "";
  }

  async function openQuickView(handle) {
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    body.innerHTML = `<div class="quick-view-loading">Loading…</div>`;

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      body.innerHTML = renderProduct(product);
      wireVariantPicker(body, product);
    } catch (err) {
      body.innerHTML = `<p>Sorry, this product couldn't be loaded.</p>`;
      console.error(err);
    }
  }

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "PKR" });
  }

  function renderProduct(product) {
    const firstVariant = product.variants[0];
    const onSale = firstVariant.compare_at_price > firstVariant.price;
    const optionsHtml = product.options.map((name, i) => {
      const values = [...new Set(product.variants.map(v => v[`option${i + 1}`]))];
      return `
        <div class="qv-option">
          <label>${name}</label>
          <div class="qv-option-values">
            ${values.map(v => `<button type="button" class="qv-option-btn" data-option-index="${i}" data-value="${v}">${v}</button>`).join("")}
          </div>
        </div>`;
    }).join("");

    return `
      <div class="qv-grid">
        <div class="qv-media">
          <img src="${product.featured_image}" alt="${product.title}" width="500" height="650">
        </div>
        <div class="qv-info">
          <h2 class="serif">${product.title}</h2>
          <div class="qv-price" data-qv-price>
            ${onSale ? `<span class="old">${money(firstVariant.compare_at_price)}</span>` : ""}
            <span class="new">${money(firstVariant.price)}</span>
          </div>
          <div class="qv-options">${optionsHtml}</div>
          <input type="hidden" data-qv-variant-id value="${firstVariant.id}">
          <button type="button" class="primary" data-qv-add-to-cart style="width:100%; margin-top:14px;">Add to Cart</button>
          <a href="/products/${product.handle}" class="qv-full-details">View full details</a>
        </div>
      </div>`;
  }

  function wireVariantPicker(scope, product) {
    const selections = {};

    scope.querySelectorAll(".qv-option-btn").forEach(btn => {
      if (btn.dataset.optionIndex === "0") btn.classList.toggle("selected", btn === scope.querySelector(".qv-option-btn"));
    });

    scope.querySelectorAll(".qv-option").forEach((group, i) => {
      const buttons = group.querySelectorAll(".qv-option-btn");
      buttons[0]?.classList.add("selected");
      selections[i] = buttons[0]?.dataset.value;

      buttons.forEach(btn => {
        btn.addEventListener("click", () => {
          buttons.forEach(b => b.classList.remove("selected"));
          btn.classList.add("selected");
          selections[i] = btn.dataset.value;
          updateVariant();
        });
      });
    });

    function updateVariant() {
      const match = product.variants.find(v =>
        Object.keys(selections).every(i => v[`option${parseInt(i) + 1}`] === selections[i])
      );
      if (!match) return;
      scope.querySelector("[data-qv-variant-id]").value = match.id;
      const priceEl = scope.querySelector("[data-qv-price]");
      const onSale = match.compare_at_price > match.price;
      priceEl.innerHTML = `${onSale ? `<span class="old">${money(match.compare_at_price)}</span>` : ""}<span class="new">${money(match.price)}</span>`;
    }

    scope.querySelector("[data-qv-add-to-cart]").addEventListener("click", async (e) => {
      const btn = e.target;
      const variantId = scope.querySelector("[data-qv-variant-id]").value;
      btn.textContent = "Adding…";
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        document.dispatchEvent(new CustomEvent("cart:updated"));
        btn.textContent = "Added ✓";
        setTimeout(() => { btn.textContent = "Add to Cart"; }, 1500);
      } catch (err) {
        btn.textContent = "Try again";
        console.error(err);
      }
    });
  }
});
